<template>
  <section class="section section--elevated">
    <div class="container">
      <h2 class="section-title">实例规格</h2>
      <p class="section-lead">全架构服务器产品矩阵，承接多样化硬件定制需求</p>
      <div class="instance-table">
        <table>
          <thead>
            <tr>
              <th>服务器类型</th>
              <th>处理器/芯片</th>
              <th>核心特性</th>
              <th>适用场景</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in instances" :key="row.type">
              <td>
                <strong>{{ row.type }}</strong>
                <span v-if="row.hot" class="instance-badge">热门</span>
              </td>
              <td>{{ row.chip }}</td>
              <td>{{ row.feature }}</td>
              <td>{{ row.scene }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const instances = [
  { type: 'X86 通用服务器', chip: 'Intel / AMD', feature: '强大通用算力，兼容性与扩展性极佳', scene: '虚拟化、云计算、HPC' },
  { type: 'C86 海光服务器', chip: '海光 7490/7420D', feature: '完美适配国产方德操作系统，信创成熟落地', scene: '党政、金融信创场景' },
  { type: 'ARM 熠知服务器', chip: '熠知 THINKFORCE 64G', feature: '能效比突出，原生支持AI训推一体部署', scene: '边缘与中心协同算力', hot: true },
  { type: 'ARM 中兴珠峰', chip: 'ZhuFengXin 8166/8157', feature: '4张瀚博VG1000-32G，256GB DDR5', scene: '云游戏渲染、大数据处理' },
  { type: 'NVIDIA GPU 全栈', chip: 'A100 / H100 / L40S', feature: '完整CUDA软件栈，极致性能', scene: '超算、大模型训练' },
  { type: '国产GPU 规模化', chip: '昇腾/寒武纪/摩尔线程等', feature: '自主可控，大批量国产化部署经验', scene: '政企智算、安全合规场景' }
];
</script>

<style scoped>
.section--elevated {
}

.section-lead {
  text-align: center;
  color: var(--fg-secondary);
  max-width: 700px;
  margin: 0 auto;
}
</style>
